import { TokensMath } from '../../../Fct/plugins/tokensMath';
import createMulticallPlugin from './generic/createMulticallPlugin';
export var MultiMultiplier = createMulticallPlugin({
    plugin: TokensMath.getters.Multiply,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY:VIEWONLY',
    method: 'multiCall',
    name: 'multiMultiplier',
    config: {
        params: [
            { key: 'methodParams.amount1', multicallKey: 'amount1' },
            { key: 'methodParams.decimals1', multicallKey: 'decimals1' },
            { key: 'methodParams.amount2', multicallKey: 'amount2' },
            { key: 'methodParams.decimals2', multicallKey: 'decimals2' },
            { key: 'methodParams.decimalsOut', multicallKey: 'decimalsOut' },
        ],
        tupleName: 'muls',
    },
    addPluginOnInit: true,
    withPluginOutputs: true,
});
